var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Ask',{ref:"ask",attrs:{"canAccept":true}},[_c('TextArea',{attrs:{"height":"180","placeholder":"Reason for rejection","auto-grow":false,"no-resize":true,"value":_vm.reason},on:{"change":_vm.change}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }